import { css, mediaQueries } from '@eti/styles';
import { Heading, Inline, Radio, RadioGroup, Stack, vars } from '@etg/wings';
import { price as priceUtil } from '@eti/utils';
import type { ChangeEventHandler } from 'react';
import QuickSortPriceAndTime from './QuickSortPriceAndTime';
import { quickSortPricesType } from './quickSortConstants';
import type { QuickSortOptionType } from './utils';

interface RadioFilterProps {
  name?: string;
  onChange: ChangeEventHandler<HTMLInputElement>;
  option: QuickSortOptionType;
  selectedValue: string;
  sortPrices: {
    bestValue: number;
    carrierPromo: number;
    cheapTrip: number;
    recommendation: number;
    shortTrip: number;
  };
}

const labelStyles = css`
  align-items: center;
  display: flex;
  justify-content: space-between;
`;

const filterWrapperStyles = css`
  flex: 0 0 100%;
  max-width: 100%;
  padding-block: 16px;

  @media ${mediaQueries.medium.up} {
    flex: 0 0 calc(50% - 15px);
    max-width: calc(50% - 15px);
  }
`;

const sortingStackContentStyles = css`
  flex: 1;
`;

const descriptionTextStyles = css`
  color: #737373;
  font-size: 0.75rem;
`;

const dividerStyles = css`
  border-top: 1px solid ${vars.colors.divider};
  width: 100%;
`;

const RadioFilter = ({
  name = 'QUICKSORT_FILTER',
  onChange,
  option,
  selectedValue,
  sortPrices,
}: RadioFilterProps) => {
  const formattedPrice = priceUtil.formatPrice(
    sortPrices[quickSortPricesType[option?.value] as keyof typeof sortPrices],
  );

  return (
    <>
      <section className={filterWrapperStyles}>
        <RadioGroup name={name} onChange={onChange} selectedValue={selectedValue}>
          <Radio.Label
            data-testid="quickFilter-radio-label"
            htmlFor={option.labelKey.replace(' ', '')}
          >
            <Inline className={labelStyles} spacing={8}>
              <Stack className={sortingStackContentStyles} spacing={8}>
                <Heading level={4}>{option.labelKey}</Heading>
                <QuickSortPriceAndTime formattedPrice={formattedPrice} time="" />
                {option?.desc && <span className={descriptionTextStyles}>{option.desc}</span>}
              </Stack>
              <Radio id={option.labelKey.replace(' ', '')} value={option.value} />
            </Inline>
          </Radio.Label>
        </RadioGroup>
      </section>
      <div className={dividerStyles} />
    </>
  );
};

export default RadioFilter;
